import {historyBackButtonDirective} from "./history-back-button/history-back-button.directive";
import emptyModule                  from "./empty/empty";
import getAvatarFilter              from "./get-avatar/get-avatar.filter";
import {confirmModule}            from "./confirm/confirm";
import {uploadAvatarModule}       from "./upload-avatar/upload-avatar";
import {fileChangeDirective}      from "./file-change/file-change.directive";
import {uploadModule}             from "./upload/upload";
import {infoModule}								from "./info/info";

import {
	defaultDateFormat,
	defaultDateFormatDays,
	defaultDateFormatDaysAndHours,
	defaultDateFormatHours,
} from "./dates/dates.filters";
import getFileName from "./get-file-name/get-file-name.filter";


export const UtilityModule = angular
	.module("utility", [
		emptyModule.name,
		confirmModule.name,
		uploadAvatarModule.name,
		uploadModule.name,
		infoModule.name
	])
	.directive("fileChange", fileChangeDirective.create)
	.directive("historyBackButton", historyBackButtonDirective.create)
	.filter("getAvatar", getAvatarFilter)
	.filter("defaultDateFormat", defaultDateFormat)
	.filter("defaultDateFormatDays", defaultDateFormatDays)
	.filter("defaultDateFormatDaysAndHours", defaultDateFormatDaysAndHours)
	.filter("defaultDateFormatHours", defaultDateFormatHours)
	.filter("getFileName", getFileName);


// WEBPACK FOOTER //
// ./sources/utility/utility.js